import React from "react";
import img from "./img.svg";
export default class InformationIcon extends React.Component {
    static defaultProps = {
        className: "",
    };
    render() {
        return (React.createElement("img", { src: img, alt: "Information", className: `${this.props.className}` }));
    }
}
